export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/files-icon.svg?28481aaacbd580bb4501f8040dcf607d";